import { textFieldFormControlBase, resourceFormStyle, heightlessTextFieldFormControlBase } from '../../../css/style';

const resourceFormStyles = resourceFormStyle();

const buttonStyleBase = {
  width: '180px',
  height: '40px',
  borderRadius: '5px',
  fontSize: '0.75rem',
};
const tallerTextFieldFormControl = {
  ...textFieldFormControlBase,
  height: '40px',
};
const PX_BETWEEN_TWO_FIELDS = 15;
const styles = theme => ({
  pageTopSectionParent: {
    height: '125px',
    padding: '0 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    backgroundColor: theme.palette.primary.background,
  },
  pageMainSectionParent: {
    backgroundColor: theme.palette.primary.pageMainBackgroundGrey,
    padding: '25px',
  },
  pageTopSectionVerticalQuarter: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
  },
  pageTitle: {
    fontSize: '1.75rem',
  },
  saveButtonsParent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  saveButtonsSpacer: {
    width: '20px',
    height: '40px',
  },
  optionScrollTarget: {
    height: '1px',
  },
  saveModifierButton: {
    ...buttonStyleBase,
    fontFamily: 'Lato',
    border: 'solid 1px #e0592a',
    '&:hover': {
      backgroundColor: '#e0592a',
      color: '#ffffff',
    },
  },
  disabledSaveModifierButton: {
    ...buttonStyleBase,
    fontFamily: 'Lato',
  },
  sectionTitle: {
    fontWeight: '700',
    fontSize: '1.25rem',
    color: '#000000',
    margin: '0 0 20px 0',
  },
  modifierFieldsPaper: {
    padding: '20px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    margin: '0 0 30px 0',
  },
  primaryButton: {
    ...buttonStyleBase,
    color: '#ffffff',
    backgroundColor: '#e0592a',
    '&:hover': {
      backgroundColor: '#ff875e',
    },
  },
  secondaryButton: {
    ...buttonStyleBase,
    color: '#ffffff',
    backgroundColor: '#000000',
    margin: '0 0 0 20px',
    '&:hover': {
      backgroundColor: '#505050',
    },
  },
  fieldSectionParent: {
    padding: '12.5px',
    border: 'solid 0.5px #979797',
    borderRadius: '5px',
    margin: '0 0 20px 0',
  },
  lastFieldSectionParent: {
    padding: '12.5px',
    border: 'solid 0.5px #979797',
    borderRadius: '5px',
    margin: '0',
  },
  halfPaperWidthFieldGroup: {
    width: '50%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  fullPaperWidthFieldGroup: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  singleFieldParent: {
    width: `calc(50% - ${PX_BETWEEN_TWO_FIELDS}px)`,
    padding: `${PX_BETWEEN_TWO_FIELDS / 2}px`,
  },
  singleFieldParentMobile: {
    width: `calc(50% - ${PX_BETWEEN_TWO_FIELDS}px)`,
    padding: `${PX_BETWEEN_TWO_FIELDS / 2}px`,
  },
  fullWidthSingleFieldParent: {
    width: `calc(100% - ${PX_BETWEEN_TWO_FIELDS}px)`,
    padding: `${PX_BETWEEN_TWO_FIELDS / 2}px`,
  },
  fullWidthSwitchFieldParent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textFieldFormControl: {
    ...tallerTextFieldFormControl,
    border: '1px solid #979797',
  },
  errorBorder: {
    ...tallerTextFieldFormControl,
    border: '1px solid red',
  },
  multilineTextFieldFormControl: {
    ...heightlessTextFieldFormControlBase,
    border: '1px solid #979797',
    minHeight: '92px',
  },
  textFieldMuiInput: {
    width: '100%',
  },
  fieldTitle: {
  },
  largeFieldTitle: {
    fontWeight: '700',
    fontSize: '1.25rem',
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 7.5px',
  },
  iosSwitch: resourceFormStyles.iosSwitchStyles,
  validationError: {
    color: 'red',
  },
});

export {
  styles,
};
